import z from 'zod'

import { ASSOCIATED_TYPES } from '@/models'

/** Single source of truth for profile association identity and `/arc/profile` search. */
export const profileIdentitySchema = z.object({
  id: z.string(),
  type: z.enum(ASSOCIATED_TYPES),
})

export type ProfileIdentity = z.infer<typeof profileIdentitySchema>
